import { ConsoleMonitoringService } from "./sentryMonitoring";
import { IMonitoringService } from "./types";

export const monitoring: IMonitoringService = new ConsoleMonitoringService();

export type { IMonitoringService };
export { ConsoleMonitoringService };